import {AgentSearchResult, AgentOffice} from "app/shared/model/Agent";
import { AgentSelectionMode } from "app/shared/model/AgentSelectionMode";

export type AgentState = {
    selectionMode: AgentSelectionMode,
    search: AgentSearch,
    agents: AgentSelectionMap,
    treeState: SubtreeStateMap,
    offices: AgentOffices
}

export enum AgentSearchState {
    NoTerm,
    Searching,
    Loaded,
    Failed
}

export type OfficeSelection = {
    office: AgentOffice,
    isSelected: boolean
}

export type AgentSearch = {
    searchTerm: string,
    searchState: AgentSearchState,
    results: AgentSearchResult[]
}

export type AgentSelection = {
    agent: AgentSearchResult,
    isChecked: boolean,
    isIndeterminate: boolean
}

export type AgentSelectionMap = {
    [agentId: string]: AgentSelection|undefined
}

export enum SubtreeState {
    Loading = 1,
    Errored = 2,
    Open = 3,
    Closed = 4
}

export type SubtreeStateMap = {
    [id: string]: SubtreeState
}

export type AgentOffices = {
    idMap: {[id: string]: OfficeSelection},
    byAgent: {[agentId: string]: string[]|undefined}
}